const { h, render, Component } = require('preact');
const CommonStatus = require('./common_status')

class GetawaysOrderStatus extends Component {
  constructor() {
    super();
  }

  render({order}, state) {
    const checkInDate = order.status.checkInDate
    return (<div>
              <CommonStatus label={checkInDate.label} value={checkInDate.value}/>
            </div>)
  }

}
module.exports = GetawaysOrderStatus
